/** Quien puede llevar una herramienta interna.
 *
 * Una herramienta interna opera la plataforma -crear agentes, asignar cosas- y
 * un agente publico atiende a clientes. El backend rechaza esa combinacion; el
 * Studio la impide antes, y la pagina de herramientas las agrupa aparte.
 *
 * Vive fuera de las paginas porque lo usan las dos, y porque una pagina que
 * exporta funciones rompe el refresco en caliente.
 */

import type { MCPAction } from '@/types/tool'

export type ToolVisibilityValue = 'internal' | 'external' | 'mixed'

export function getToolVisibility(tool: MCPAction): ToolVisibilityValue {
  return tool.classification === 'internal' || tool.classification === 'mixed'
    ? tool.classification
    : 'external'
}

/** Si una herramienta no se puede marcar en este agente.
 *
 * Una que ya estuviera marcada **si** se deja quitar, o un agente que la lleve
 * de antes se quedaria sin poder arreglarse.
 */
export function herramientaBloqueadaPorAudiencia(
  audience: string,
  visibility: ToolVisibilityValue,
  selected: boolean
): boolean {
  return audience === 'public' && visibility === 'internal' && !selected
}
